import styled from 'styled-components';
import { Tab, Box, Checkbox } from '@mui/material';
import { MenuItem } from 'spw-components/worksheet/styles';
import { colors } from 'spw-theme';

export const NotesTab = styled(Tab)`
  && {
    border: 1px solid #e0e0e0;
    height: 42;
    padding: 0px 16px;
    margin-right: 16px;
    border-radius: 3px;

    &.Mui-selected {
      background: #eeeeee;
    }
  }
`;

export const NotesContainer = styled(Box)`
  && {
    padding-top: 24px;
    width: 100%;
  }
`;

export const NotesContent = styled.div`
  && {
    background-color: white;
    width: 100%;

    &.m-4 {
      margin-left: 4px;
      margin-top: 4px;
    }

    &.worksheet-notes {
      margin-left: 0px;
      margin-bottom: 0px;
      padding-bottom: 0px;
    }

    &.show-border {
      border-bottom: solid 1px ${colors.offWhite};
    }
  }
`;

export const NotesTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  margin-bottom: 4px;
  text-transform: uppercase;
`;

export const NotesDepartmentName = styled.div`
  margin-left: 10px;
  font-style: normal;
  font-weight: normal;
  text-transform: uppercase;
  color: ${colors.fontColor};
`;

export const NotesCategoryName = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  text-transform: uppercase;
  color: ${colors.fontColor};
  padding-bottom: 9px;
  padding-left: 10px;
  padding-top: 12px;

  background-color: white;
`;

export const NotesScenarioName = styled('div')<{ marginLeft?: number }>`
  && {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 12px;
    text-transform: uppercase;
    color: #4a4a4a;
    padding-bottom: 9px;
    margin-left: ${(props) => props.marginLeft || 0}px;
  }
`;

export const NoteText = styled.div`
  font-size: 14px;
  line-height: 20px;
  overflow-wrap: break-word;
  width: 996px !important;
  word-wrap: break-word;

  &.worksheet-note {
    overflow-wrap: break-word;
    width: 950px !important;
  }
`;

export const NoteSecondaryIdentifier = styled.span`
  font-weight: normal;
`;

export const NoteContent = styled(Box)`
  && {
    padding-bottom: 12px;
    margin-bottom: 0px;
  }

  &&.worksheet-notes {
    div:first-child {
      margin-left: 6px;
    }
  }
`;

export const NotesListTitleContainer = styled.div`
  &&.empty {
    margin-bottom: 25px;
  }
`;

export const NoteTabsContainer = styled(Box)`
  width: 100%;
`;

export const NotesMenuItem = styled(MenuItem)`
  && {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    padding: 8px 16px;

    &.title {
      font-weight: bold;
      font-size: 10px;
      line-height: 12px;
      letter-spacing: 0.25px;
      text-transform: uppercase;
      color: #919191;
      opacity: unset;
    }
  }
`;

export const RSFLabel = styled(Box)`
  font-size: 12px;
  line-height: 1;
  margin-top: 1px;
`;

export const RndBulkEditCardPopoverContent = styled.div`
  box-sizing: border-box;

  .description > p {
    margin: 0;

    &:not(:first-child) {
      margin-top: 24px;
    }
  }

  .actions {
    > :not(:first-child) {
      margin-left: 16px;
    }
  }

  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 630px;

  .drag-handle {
    cursor: move;
  }

  .title {
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    text-transform: uppercase;
    padding: 24px 24px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .name-type {
    font-size: 12px;
    line-height: 16px;
  }

  .warning {
    margin-top: 16px;
    color: ${colors.red};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }

  .content {
    padding: 0 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .description {
    margin-top: 16px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .MuiTextField-root {
    margin-top: 37px;
    width: 94px;

    .MuiInputBase-input {
      height: 40px;
      box-sizing: border-box;
    }
  }

  .current-avg {
    margin-top: 24px;
  }

  .table-wrapper {
    margin: 24px 0 0;
    flex: 1;
  }

  .actions {
    padding: 20px 24px 36px;
    margin-top: 0;
    background-color: white;
    border-radius: 0 0 9px 9px;

    & > button {
      width: 88px;
      z-index: 1;
      pointer-events: auto;

      &.MuiButton-root:hover.Mui-disabled {
        background-color: ${colors.veryLightGray};
        opacity: unset;
      }
    }
  }
`;

export const ScenariosTableContainer = styled.div`
  border: 1px solid ${colors.mainGray};
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
  overflow-y: auto;
  position: relative;

  .header {
    background-color: ${colors.containerBorder};
    position: sticky;
    top: 0;
    z-index: 2;
  }

  .row {
    height: 48px;
    display: flex;
    border-top: 1px solid ${colors.mainGray};
  }

  .nested-row,
  .tps-nested-row {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    background-color: ${colors.lightGreyBackground};
  }

  .cell {
    display: flex;
    align-items: center;
  }

  .checkbox-cell {
    width: 50px;
  }

  .icon-cell {
    width: 46px;

    > img {
      margin: auto;
    }
  }

  .text-cell {
    padding-left: 4px;
    width: 263px;
    box-sizing: border-box;
  }

  .secondary-text-cell {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .value-cell {
    left: 483px;
    position: absolute;
    width: 52px;
    justify-content: flex-end;
  }

  .header .row {
    border-top: none;
  }

  .header .row .text-cell {
    padding-left: 16px;
  }

  .header .row .checkbox-cell {
    justify-content: center;
    border-right: 2px solid ${colors.tableHeaderInnerBorderGray};
  }

  .body .row .checkbox-cell {
    justify-content: center;
    border-right: 2px solid ${colors.containerBorder};
  }

  .nested-row .text-cell {
    padding-left: 46px;
  }

  .icon-cell + .text-cell {
    padding-left: 0;
    width: 217px;
  }

  .tps-nested-row .text-cell {
    padding-left: 0;
  }
`;

export const ScenariosTableCheckbox = styled(Checkbox)`
  color: ${colors.fontColor};
`;
